import { connect } from 'react-redux';

import { handleAjaxError, showSuccessFlag } from '@helpcenter/flags';
import type { State } from 'state';
import { resetLogin } from 'state/actions/login';
import { getBaseUrl } from 'state/selectors/env';
import ForgotPasswordConfirmation from './forgot-password-confirmation';

export default connect(
	(state: State) => ({
		baseUrl: getBaseUrl(state),
	}),
	{
		resetLoginAction: resetLogin,
		onResendLinkError: handleAjaxError,
		onResendSuccess: showSuccessFlag,
	},
)(ForgotPasswordConfirmation);
